import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@material-ui/core';

interface IProps extends ButtonProps {
  loading: boolean | undefined;
}

const LoadingButton: React.FC<IProps> = ({
  loading,
  children,
  type = 'button',
  variant = 'contained',
  color = 'primary',
  fullWidth = false,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      type={type}
      variant={variant}
      color={color}
      disabled={loading}
      fullWidth={fullWidth}
    >
      {loading ? (
        <>
          <CircularProgress size={15} style={{ margin: '4px' }} />
          Carregando
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
